export const NATIVE_APP_AGENT = 'ChocoPartnerApp';
